/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Gentle_Calm_Heron_RestInputs */

const en_gentle_calm_heron_rest = /** @type {(inputs: Gentle_Calm_Heron_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exactly ${i?.value}`)
};

const de_gentle_calm_heron_rest = /** @type {(inputs: Gentle_Calm_Heron_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genau ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Exactly {value}" |
*
* @param {Gentle_Calm_Heron_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gentle_calm_heron_rest = /** @type {((inputs: Gentle_Calm_Heron_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gentle_Calm_Heron_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gentle_calm_heron_rest(inputs)
	return de_gentle_calm_heron_rest(inputs)
});